"use client";
import { DescriptionLink } from "@/components/CTA/variants/MultiCourse/descriptions/DescriptionLink";
import { ClientOnly } from "@/components/Cohesion/ClientOnly";
import useTranslations from "@/i18n/useTranslations";

export default function ChangeDescription() {
  const t = useTranslations("MultiCourse");
  let pos = 0;
  return (
    <ClientOnly>
      <div className="Content_intro__4CkTF">
        <p>
          <DescriptionLink
            url="/certificates/professional-certificate"
            text="Professional certificate"
            visibleText={t("professionalCertificate")}
            position={`${++pos}`}
            variant="professional-certificate"
          />{" "}
          {t("changeIntroRest")}
        </p>
        <ul className="list-disc">
          <li>{t("changeBullet1")}</li>
          <li>{t("changeBullet2")}</li>
          <li>{t("changeBullet3")}</li>
          <li>
            {t("changeBullet4Before")}{" "}
            <DescriptionLink
              url="https://careers.edx.org/guides-and-templates"
              text="guides and templates"
              visibleText={t("guidesAndTemplates")}
              position={`${++pos}`}
              variant="guides-and-templates"
            />{" "}
            {t("changeBullet4After")}
          </li>
        </ul>
        <p>
          <i>{t("strengtheningYour")} </i>
          {t("resumeWord")}
          <i>? {t("explore")} </i>
          <DescriptionLink
            url="/certificates"
            text="certificate programs"
            visibleText={t("certificatePrograms")}
            position={`${++pos}`}
            variant="certificate-programs"
          />
          <b>.</b>
        </p>
      </div>
    </ClientOnly>
  );
}
